// extracted by mini-css-extract-plugin
export default {"more":"Description_more__L3Ohs","root":"Description_root__Dup6j"};